import React from 'react'

interface Props {
  title?: string
  onClick: () => void
}

export default function SignInBackButton({ onClick, title }: Props) {
  return (
    <div className="flex flex-col w-full">
      <hr className="mb-6 w-full" />
      <button
        type="button"
        className="w-full h-12 bg-gray-200 text-gray-700 px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-gray-300 transition duration-150 ease-in-out hover:shadow-lg active:bg-gray-400"
        onClick={onClick}
      >
        {title || 'Back'}
      </button>
    </div>
  )
}
